export default __webpack_public_path__ + "static/media/037-flour.33dfe971.svg";